export const SET_VISITED_LIST = "SET_VISITED_LIST";
export const SET_IP_LOCATION = "SET_IP_LOCATION";
export const SET_FOOTER_LOCATIONS = "SET_FOOTER_LOCATIONS";
export const SET_SEARCH_HISTORY = "SET_SEARCH_HISTORY";
export const SET_AVAILABILITY = "SET_AVAILABILITY";
export const SET_BOOKUN_WEBHOOK = "SET_BOOKUN_WEBHOOK";
export const SET_FAREHARBOR_WEBHOOK = "SET_FAREHARBOR_WEBHOOK";








